import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { SaveCustomerPayload } from "helpers/WizardHelper";
import { MyCustomer } from "models/customers/customers";
import { useRootStore } from "store";

export class CustomersAPI {
  static async searchForCustomers(searchTerm: string): Promise<MyCustomer[]> {
    const response = await request
      .get(config.api.customer.findAllCustomers)
      .set("Authorization", "Bearer " + getTabToken())
      .query({
        Find: searchTerm
      });
    const result: MyCustomer[] = response.body;
    return result;
  }

  static async closeCustomer(customerId: string) {
    return new Promise((resolve, reject) => {
      request
        .put(config.api.customer.close(customerId))
        .set("Authorization", "Bearer " + getTabToken())
        .end((err, res) => {
          err ? reject({ err, res }) : resolve(res);
        });
    });
  }

  static async getCustomersInternal(): Promise<MyCustomer[]> {
    const response = await request
      .get(config.api.user.customers)
      .set("Authorization", "Bearer " + getTabToken())
      .send();
    const result: MyCustomer[] = response.body.items;
    return result;
  }

  static async getCustomerSettings(id: string) {
    const response = await request
      .get(config.api.customer.get(id))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send();
    return response.body;
  }

  static async saveCustomer(customerPayload: SaveCustomerPayload) {
      const { user } = useRootStore.getState();
    return await request
      .post(config.api.customer.save)
      .set("Authorization", "Bearer " + user.token)
      .send(customerPayload);
  }
}
